import styled from 'styled-components'

import { theme, breakpoints } from '../builderUtils/theme'

// Styled components
export const SectionContainer = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 1rem;
  background-color: ${(props) => (props.hasCreamBackground ? theme.cream : theme.sky)};

  @media (max-width: ${breakpoints.m}px) {
    padding: 1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
export const MediaContainer = styled.div`
  display: flex;
  justify-content: center;
  align-self: stretch;
  padding: 1rem 0;

  @media (max-width: ${breakpoints.m}px) {
    align-items: center;
    padding: 0;
  }
`

export const MobileMediaWrapper = styled.div`
  display: none;

  @media (max-width: ${breakpoints.m}px) {
    display: block;
    width: 100%;
  }
`
export const DesktopMediaWrapper = styled.div`
  display: block;
  width: 50%;
  padding: 1rem 0;
  @media (max-width: ${breakpoints.m}px) {
    display: none;
  }
`
export const HeroImage = styled.img`
  object-fit: contain;
  align-self: stretch;
  margin: auto 0;
  aspect-ratio: 1.08;
  min-width: 15rem;
  width: 600px
  height: 555px
  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
    align-items: center;
  }
`

export const HeroVideo = styled.video`
  object-fit: contain;
  align-self: stretch;
  margin: auto 0;
  aspect-ratio: 1.08;
  min-width: 15rem;
  width: 601px;

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
    max-height: 100%;
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 15rem;
  width: 50%;

  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`
export const ContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${(props) => (props.textLeft ? 'flex-start' : 'flex-end')};
  margin: auto 0;
  padding: 1.5rem;
  min-width: 15rem;
  width: 100%;

  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    padding: 1rem;
    align-items: center;
    justify-content: center;
  }
`

export const Header = styled.header`
  width: 100%;

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
  }
`

export const Headline = styled.h2`
  font-family: 'FilsonPro';
  font-size: 42.75px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 51.3px */
  letter-spacing: -1.069px;
  color: ${theme.onboardGray};
  text-align: ${(props) => (props.textLeft ? 'left' : 'right')};

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 43.2px */
    letter-spacing: -0.52px;
    text-align: center;
  }
`

export const Description = styled.p`
  font-family: 'FilsonPro';
  font-size: 23.625px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 35.438px */
  color: ${theme.onboardGray};
  text-align: ${(props) => (props.textLeft ? 'left' : 'right')};

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    text-align: center;
  }
`
